import { Environment, PlatformType } from './common';
export const UNKNOWN_VALUE = 'airTracker_unknown';
export const DEFAULT_CONFIG = {
    appName: UNKNOWN_VALUE,
    appVersion: UNKNOWN_VALUE,
    env: Environment.staging,
    delay: 2000,
    errorRepeatTime: 3,
    enableErrorMonitoring: false,
    enableWebVitals: false,
    enableAssetSpeedMonitoring: false,
};
export const DEFAULT_COMMON_DATA = {
    appName: UNKNOWN_VALUE,
    env: Environment.staging,
    sessionId: UNKNOWN_VALUE,
    deviceId: UNKNOWN_VALUE,
    platform: PlatformType.other,
};
